import React, { useState, useEffect, useRef } from "react";
import "./LoginModal.css";
import axiosConfig from "../../Service/AxiosConfig";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useAuth } from "../Utils/AuthContext";
import { HiArrowLongLeft } from "react-icons/hi2";
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useLocationContext } from "../../context/LocationContext";
import sandyLoading from "../Animations/Sandy Loading.gif";
const LoginModal = ({ isOpen, onClose, serviceId, title, image }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const firstOtpRef = useRef(null);
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("login");
  const { login } = useAuth();
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [lead_id, setLeadId] = useState(null);
  const { location } = useLocationContext();
  const [formData, setFormData] = useState({
    name: "",
    mobileno: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    mobileno: "",
    otp: "",
  });

  useEffect(() => {
    if (!isOpen) resetForm();
  }, [isOpen]);
  useEffect(() => {
    if (step === "otp" && firstOtpRef.current) {
      firstOtpRef.current.focus();
    }
  }, [step]);

  useEffect(() => {
    if (isOpen) {
      const token = localStorage.getItem("token");
      const mobileno = localStorage.getItem("mobileno");
      if (token && mobileno) {
        setFormData({ name: "", mobileno });
        setOtpSent(false);
      }
    }
  }, [isOpen]);
  useEffect(() => {
    if (step !== "otp") return;

    if (timer <= 0) {
      setCanResend(true);
      return;
    }

    setCanResend(false);

    const countdown = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(countdown);
  }, [timer, step]);

  useEffect(() => {
    if (otp.length === 4 && step === "otp") {
      handleVerifyOTP();
    }
  }, [otp, step]);

  const resetForm = () => {
    setFormData({ name: "", mobileno: "" });
    setOtp("");
    setOtpSent(false);
    setLoading(false);
    setTimer(30);
    setCanResend(false);
    setStep("login");
    setLeadId(null);
    setErrors({ name: "", mobileno: "", otp: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleBookNow = async () => {
    const { name, mobileno } = formData;
    let newErrors = {};
    let hasError = false;

    if (!name.trim()) {
      newErrors.name = "Please enter patient name";
      hasError = true;
    }
    if (!mobileno.trim()) {
      newErrors.mobileno = "Please enter mobile number";
      hasError = true;
    } else if (mobileno.length !== 10) {
      newErrors.mobileno = "Mobile number must be 10 digits";
      hasError = true;
    }

    if (hasError) return setErrors(newErrors);

    const token = localStorage.getItem("token");
    setLoading(true);

    try {
      if (token) {
        const leadData = {
          mobileno,
          name,
          service: serviceId,
          source: "Website",
          city: location?.city || "",
        };
        const res = await axiosConfig.post("/accounts/leads/", leadData, {
          headers: { Authorization: `Token ${token}` },
        });

        if (res?.data?.lead?.id) {
          setLeadId(res.data?.lead?.lead_id);
          setStep("success");
        }
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("mobileno", mobileno);

        await axiosConfig.post("/accounts/validate_mobile/", data);

        setOtpSent(true);
        setStep("otp");
        setTimer(30);
        setCanResend(false);
      }
    } catch (err) {
      newErrors.mobileno = err.response?.data?.error || "Something went wrong";
      setErrors(newErrors);
    }

    setLoading(false);
  };

  const handleVerifyOTP = async () => {
    if (loading) return;
    const { name, mobileno } = formData;
    let newErrors = {};
    let hasError = false;

    if (!otp.trim()) {
      newErrors.otp = "Enter OTP";
      hasError = true;
    } else if (otp.length !== 4) {
      newErrors.otp = "OTP must be 4 digits";
      hasError = true;
    }

    if (hasError) return setErrors(newErrors);

    setLoading(true);

    try {
      const verify = new FormData();
      verify.append("mobileno", mobileno);
      verify.append("otp", otp);
      const res = await axiosConfig.post("/accounts/verify_otp/", verify);
      if (res?.data?.message === "Verification successful.") {
        login(res.data?.token, res.data?.user_id);
        const leadData = {
          mobileno,
          name,
          service: serviceId,
          source: "Website",
          city: location?.city || "",
        };

        const leadRes = await axiosConfig.post("/accounts/leads/", leadData, {
          headers: { Authorization: `Token ${res.data?.token}` },
        });

        setLeadId(leadRes.data?.lead?.lead_id);
        localStorage.setItem("mobileno", leadRes?.data?.user?.mobileno);
        setOtp("");
        setStep("success");
      } else {
        newErrors.otp = "Invalid OTP";
        setErrors(newErrors);
      }
    } catch (err) {
      newErrors.otp = err.response?.data?.error || "Verification failed";
      setErrors(newErrors);
    }
    setLoading(false);
  };

  const handleResendOTP = () => {
    if (!canResend || loading) return;
    handleBookNow();
  };

  const handleBack = () => {
    if (step === "otp") {
      setStep("login");
      setOtp("");
      setErrors((prev) => ({ ...prev, otp: "" }));
    }
  };

  if (!isOpen) return null;
  let mobile = localStorage.getItem("mobileno");

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <IoIosCloseCircleOutline
          size={40}
          className="close-button"
          onClick={!loading ? onClose : undefined}
        />

        <div className="border-btm">
          <div className="service-image">
            <img src={image} alt="logo" />
          </div>
          <h3 className="title-services">
            Booking For <strong>{title}</strong>
          </h3>
        </div>

        {step === "login" && (
          <form className="modal-form">
            <div className="bg-dft">
              <p>
                Enter your details to quickly book a certified {title} near
                you.
              </p>
            </div>

            <label>Patient Name</label>
            <div className="input-wrapper">
              <input
                name="name"
                type="text"
                placeholder="Patient Name"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            {errors.name && <p className="field-error">{errors.name}</p>}

            <label>Mobile Number</label>
            <div className="input-wrapper">
              <input
                name="mobileno"
                type="tel"
                placeholder="+91 XXXXXXXXXX"
                maxLength={10}
                value={formData.mobileno}
                disabled={!!mobile}
                onInput={(e) => {
                  if (!mobile) {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }
                }}
                onChange={(e) => {
                  if (!mobile) handleChange(e);
                }}
              />
            </div>
            {errors.mobileno && (
              <p className="field-error">{errors.mobileno}</p>
            )}

            <button
              type="button"
              className="book-button"
              onClick={handleBookNow}
            >
              {loading ? "Sending OTP..." : "Book Now"}
            </button>

            <p className="otp-error">
              We will send a one-time password (OTP) to this number.
            </p>
          </form>
        )}

        {step === "otp" && (
          <div className="otp-container">
            {loading && (
              <div className="otp-loader-overlay">
                <img src={sandyLoading} alt="Loading..." />
                <p>Verifying OTP...</p>
              </div>
            )}
            <div className="arrow-data">
              <HiArrowLongLeft
                className="F-icon"
                onClick={!loading ? handleBack : undefined}
              />
              <h3 className="otp-title">Verify Your Contact</h3>
            </div>

            <p className="otp-patient">
              Patient: <b>{formData.name}</b>
            </p>
            <p className="otp-msg">
              OTP sent to **{formData.mobileno.slice(-4)}
            </p>

            <div className="otp-input-group">
              {[0, 1, 2, 3].map((i) => (
                <input
                  key={i}
                  id={`otp-${i}`}
                  className="otp-box"
                  type="tel"
                  inputMode="numeric"
                  ref={i === 0 ? firstOtpRef : null}
                  pattern="[0-9]*"
                  maxLength={1}
                  value={otp[i] || ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    const arr = otp.split("");

                    arr[i] = val;
                    setOtp(arr.join(""));

                    if (val && i < 3) {
                      document.getElementById(`otp-${i + 1}`).focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      const arr = otp.split("");
                      if (!otp[i] && i > 0) {
                        document.getElementById(`otp-${i - 1}`).focus();
                      }
                      arr[i] = "";
                      setOtp(arr.join(""));
                    }
                  }}
                />
              ))}
            </div>
            {errors.otp && <p className="field-error">{errors.otp}</p>}
            {canResend ? (
              <b className="resend-link" onClick={handleResendOTP}>
                Resend OTP
              </b>
            ) : (
              <p className="login-msg">
                Resend in <b>{timer}s</b>
              </p>
            )}

            <p className="auto-verify-text">
              {loading
                ? "Verifying OTP..."
                : "OTP will be verified automatically"}
            </p>
          </div>
        )}

        {step === "success" && (
          <div className="success-icon">
            <IoCheckmarkCircleSharp size={60} style={{ color: "#31C07E" }} />
            <h3 className="success-text">Booking Successful!</h3>
            <p className="shortly-p">Our executive will contact you shortly</p>
            <div className="bg-color">
              <p className="booking-id">Booking ID:</p>
              <h6 className="lead-id">{lead_id}</h6>
              <p className="otp-patient">
                Patient: <b>{formData.name}</b>
              </p>
            </div>
            <div>
              <p className="shortly-p">
                In meantime, please provide the details below to help us better
                understand your exact requirements
              </p>
              <button
                className="grey-btn"
                onClick={() => navigate("/patient-dashboard/bookings")}
              >
                Add Patient Details
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginModal;
